import { TriangleAlert } from 'lucide-react';
import * as React from 'react';

import { Alert, AlertDescription } from '@/components/ui/alert';

import {
  AuthTemplate,
  FooterLinks,
} from '@/pages/unauthenticated/auth/components';

export const EmailInviteMismatch = ({
  heading,
  email,
}: {
  heading: string;
  email: string;
}) => {
  return (
    <AuthTemplate heading={heading} footer={<FooterLinks />}>
      <Alert variant="warning" className="border-0 bg-warning/80">
        <TriangleAlert className="h-5 w-5" />
        <AlertDescription className="flex flex-col gap-2 pt-0">
          <div>
            The Google account you selected doesn’t match the email address tied
            to your invitation (<span className="font-bold">{email}</span>).
          </div>
          <div>
            To proceed, please revisit the invitation link sent to your email
            and complete the registration process.
          </div>
        </AlertDescription>
      </Alert>
    </AuthTemplate>
  );
};
